type VehicleRow = { vehicleType?: string | null; pax?: number | string | null } | undefined;

const vehicleKey = (vehicle: VehicleRow): string | null => {
  const name = vehicle?.vehicleType?.trim().toLowerCase();
  return name ? `${name}|${Number(vehicle?.pax) || 0}` : null;
};

/**
 * Returns true when another vehicle already has this vehicle's name and max pax (case and spacing ignored).
 * Same name with a different max pax is allowed, for example a 29 and a 39 seater Big Bus.
 * @param vehicles All vehicles in the form
 * @param index Index of the vehicle being checked
 */
export const isDuplicateVehicle = (vehicles: VehicleRow[] | undefined, index: number): boolean => {
  const key = vehicleKey(vehicles?.[index]);
  return key !== null && (vehicles || []).some((other, otherIndex) => otherIndex !== index && vehicleKey(other) === key);
};
